<template>
  <p class="text-sm/6 text-slate-500">
    <slot />
  </p>
</template>
